import { render } from "./GetView.vue?vue&type=template&id=1ef7b8b2"
import script from "./GetView.vue?vue&type=script&lang=js"
export * from "./GetView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\rh\\Documents\\GitHub\\handover-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__